import {
  getViolationReportCategory,
  createViolationReport
} from '@/apis/violation-report';
import { VIOLATION_REPORT } from "@/store/mutation-types";
import axios from "@/plugins/axios";

export const state = {
  violationReportCategory: {},
  formViolationReport: {},
  createViolationReport: {}
};

export const getters = {
  violationReportCategory: (state) => state.violationReportCategory,
  formViolationReport: (state) => state.formViolationReport,
  createViolationReport: (state) => state.createViolationReport,
};

export const mutations = {
  [VIOLATION_REPORT.GET_ALL_VIOLATION_REPORT_CATEGORY](state, data) {
    if (!data.error) {
      state.violationReportCategory = data;
    }
  },
  [VIOLATION_REPORT.GET_FORM_VIOLATION_REPORT](state, data) {
    if (!data.error) {
      state.formViolationReport = data;
    }
  },

  [VIOLATION_REPORT.CREATE_VIOLATION_REPORT](state, data) {
    state.createViolationReport = data;
  },

  [VIOLATION_REPORT.CLEAR_FORM_VIOLATION_REPORT](state) {
    state.formViolationReport = {};
  },
};

export const actions = {
  async getViolationReportCategory({ commit }, payload) {
    const res = await getViolationReportCategory(payload);
    commit(VIOLATION_REPORT.GET_ALL_VIOLATION_REPORT_CATEGORY, res);
  },

  getFormViolationReport({ commit }, params) {
    commit(VIOLATION_REPORT.GET_FORM_VIOLATION_REPORT, params);
  },

  async createViolationReport({ commit }, formData) {
    const res = await createViolationReport(formData);
    if (res.error) {
      return res;
    }
    commit(VIOLATION_REPORT.CREATE_VIOLATION_REPORT, res);
    return false;
  },

  clearFormViolationReport({ commit }) {
    commit(VIOLATION_REPORT.CLEAR_FORM_VIOLATION_REPORT);
  },
};
